/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Readable } from '../../models/readable';

export interface ReportsControllerPdfReportGeneration$Params {

/**
 * ISO standard Alpha-2 language code.
 *     Language code to be used for report generation. The language can be different from the project language code.
 *     If the parameter is not provided the project language code is used. If you need to be sure in which language
 *      report will be generated, always use this parameter.
 */
  languageCode?: 'cs' | 'de' | 'en' | 'es' | 'fr' | 'nl' | 'pl' | 'sk';

/**
 * The ID of the project which data will be used as a content for PDF report.
 */
  projectId: string;

/**
 * The ID of the variant which data will be used as a content for PDF report.
 *     If not set, selected variant will be used.
 */
  variantId?: string;

/**
 * The type of the report that will be generated.
 */
  reportType: 'PITCH_DECK' | 'VIGUIDE_PLANNING';

/**
 * Optional query parameter(s) defining the set of sections that will be selected when generating the PDF report.
 *     When the sections list is not provided, the report will contain all possible sections.
 */
  sections?: Array<string>;

/**
 * A header used to get the application ID from the request to find the correct application instance for OAuth endpoints (authenticated).
 *             Should be used together with <code>x-application-country-code</code> header.
 */
  'x-application-id': 'HEAT_PUMP_PLANNER' | 'PHOTOVOLTAIC_PLANNER' | 'VENTILATION_PLANNER' | 'VIGUIDE_PLANNING' | 'HOME_PLANNER' | 'BOILER_PLANNER' | 'SALESFORCE';

/**
 * A header used to extract country code from the request to find the correct application instance OAuth endpoints (authenticated).
 *             Should be used together with <code>x-application-id</code> header.
 */
  'x-application-country-code': 'AT' | 'BE' | 'CH' | 'CZ' | 'DE' | 'ES' | 'FR' | 'NL' | 'PL' | 'SK';

/**
 * A header used for security reasons. Header is automatically sent by browsers. When using the code-to-API solution (calling
 *             this API directly by script code or other API) please contact <strong>Customer Apps</strong> team for more details.
 */
  referer: string;
}

export function reportsControllerPdfReportGeneration(http: HttpClient, rootUrl: string, params: ReportsControllerPdfReportGeneration$Params, context?: HttpContext): Observable<StrictHttpResponse<Readable>> {
  const rb = new RequestBuilder(rootUrl, reportsControllerPdfReportGeneration.PATH, 'get');
  if (params) {
    rb.query('languageCode', params.languageCode, {});
    rb.query('projectId', params.projectId, {});
    rb.query('variantId', params.variantId, {});
    rb.query('reportType', params.reportType, {});
    rb.query('sections', params.sections, {});
    rb.header('x-application-id', params['x-application-id'], {});
    rb.header('x-application-country-code', params['x-application-country-code'], {});
    rb.header('referer', params.referer, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Readable>;
    })
  );
}

reportsControllerPdfReportGeneration.PATH = '/planning-projects/v1-develop/reports/pdf';
